import React from 'react';
import tableau from 'tableau-api';
import { Spinner } from 'react-bootstrap';
import { withRouter } from "react-router-dom";

import SysProtocol from '../net/SysProtocol';

export default class AnalysisPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Url: null,
      Query: "",
    };

    console.log('create Analysis page');
  }

  componentDidMount() {
    //TODO: sotre id
    const path = this.props.location.pathname;
    let pages = path.split("/");
    let pageName = pages[pages.length - 1];
    SysProtocol.ins().reqGetAnalysisUrl(0, pageName, (url) => {
      console.log('get url : '+url);
      this.setState({
        Url: url
      }, this.initViz);
    });
  }
  
  initViz() {  
    const vizUrl = this.state.Url;  
    const vizContainer = this.vizContainer;  
    let viz = new window.tableau.Viz(vizContainer, vizUrl)  
  }

  render() { 
    if(this.state.Url === null){
      return (
        <div className="p-5 d-flex align-items-center flex-column">
          <Spinner animation="border" role="status" />
        </div>
      );
    }

    return (
      <div ref={(div) => { this.vizContainer = div }} style={{height:"100%"}}>  
      </div>
    );
  }
}